// @flow
import actionTypes from '../../actionTypes';
import { fetch } from '../../../api';

export default (id: IdType) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: actionTypes.POST_TOGGLE_RATE, rate: { id } });
    let payload = null;

    try {
      const state = getState();
      const post = state.data.posts[id];
      const group = state.data.groups[post.group];

      const response = await fetch(`post/${id}/rate`, {
        method: 'POST',
        body: JSON.stringify({
          id,
          op: (post && post.hasRated) ? '+' : '-',
          groupCode: group && group.groupCode,
          parentType: 'posts',
        }),
      });
      payload = response.payload;
    } catch (error) {
      dispatch({
        type: actionTypes.POST_TOGGLE_RATE_FAILURE,
        rate: { id },
        isAsynchronous: true,
        error,
      });
    }

    if (!payload) return;

    const newPost = { id, numRatings: payload.rating, hasRated: payload.hasRated };
    dispatch({
      type: actionTypes.POST_TOGGLE_RATE_SUCCESS,
      isAsynchronous: true,
      data: { posts: [newPost] },
    });
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/rate.js